export default __webpack_public_path__ + "static/media/storageUnit1-afterA-768w.8a1d2248.png";